import { render, staticRenderFns } from "./ModalChangeDesign.vue?vue&type=template&id=8566a862&scoped=true&"
import script from "./ModalChangeDesign.vue?vue&type=script&lang=js&"
export * from "./ModalChangeDesign.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeDesign.vue?vue&type=style&index=0&id=8566a862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8566a862",
  null
  
)

export default component.exports